import "./TextInputDialogComponent.scss";
import template from "./TextInputDialogComponent.html";
import {IComponentOptions, IOnInit} from "angular";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Optional} from "../../../../js/util/Optional";

export const TextDialog = "tfTextInputDialog";

interface Resolve {
    readonly title: string | null;
    readonly value: string | null;
}

export function textDialog(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controllerAs: "ctrl",
        controller: TextInputDialogComponentController
    };
}

export class TextInputDialogComponentController implements IOnInit {

    public readonly modalInstance: IModalInstanceService;
    public readonly resolve: Resolve;

    public title: string;
    public value: string | null;

    public $onInit(): void {
        this.title = Optional.of(this.resolve)
                             .map((r) => r.title)
                             .orElse("Enter Value");
        this.value = Optional.of(this.resolve)
                             .map((r) => r.value)
                             .orNull();
    }

    public confirm(value: string) {
        this.modalInstance.close(value);
    }

    public cancel() {
        this.modalInstance.dismiss();
    }
}
